import { render, staticRenderFns } from "./garbageDeliveryTypeEdit.vue?vue&type=template&id=6e19ff00&scoped=true"
import script from "./garbageDeliveryTypeEdit.vue?vue&type=script&lang=js"
export * from "./garbageDeliveryTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19ff00",
  null
  
)

export default component.exports